import React, { useContext, useRef, useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { getDoc, doc } from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../../firebase";
import ReactToPrint from "react-to-print";
import { LanguageContext } from "../../context/LanguageContext";
import TopTitleFormComponentMobileV2 from "./TopTitleFormComponentMobileV2";

function ViewGeneralLiabilityMobileV2(props) {
  const { translate } = useContext(LanguageContext);
  const [signaturePic, setSignaturePic] = useState(null);
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");

  const printRef = useRef();

  function formatDate(timestamp) {
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();

    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  const fetchSignatureUrl = async () => {
    const docRef = doc(db, "GeneralLiability", props.clientId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const { signatureURL, text1, text2, text3 } = docSnap.data();
      setSignaturePic(signatureURL);
      setText1(text1);
      setText2(text2);
      setText3(text3);
      setText4(text4);
    } else {
      console.log("No such document (signaturePic ref)!");
    }
  };

  useEffect(() => {
    fetchSignatureUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>
      <div
        // className="inputAndLabelModalContainerTitle2"
        style={{ width: "auto", height: "100%" }}
      >
        <div
          className="line1-modal-percent"
          style={{ borderBottom: "1px solid lightgray" }}
        >
          <TopTitleFormComponentMobileV2
            title={translate("GeneralLiabilityReleaseForm")}
            closemodal={props.closemodal}
          />
        </div>

        <div
          id="printableContent"
          style={{
            width: "100%",
            marginTop: "10px",
            height: "80%",
            overflowY: "scroll",
            fontSize: "16px",
          }}
          ref={printRef}
        >
          <div
            className="client-name-container"
            style={{ fontSize: "16px", paddingLeft: "10px" }}
          >
            General liability form for: {props.firstName} {props.lastName}
          </div>

          <div
            className="text-block"
            style={{ fontSize: "14px", paddingLeft: "15px" }}
          >
            {text1}
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px", paddingRight: "10px" }}
          >
            <Checkbox checked={true} />I fully understand and agree to the above
            terms.
          </div>
          <div
            className="text-block"
            style={{ fontSize: "14px", paddingLeft: "15px" }}
          >
            {text2}
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px", paddingRight: "10px" }}
          >
            <Checkbox checked={true} />I fully understand and agree to the above
            terms.
          </div>

          <div
            className="text-block"
            style={{ fontSize: "14px", paddingLeft: "15px" }}
          >
            {text3}
          </div>

          <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px", paddingRight: "10px" }}
          >
            <Checkbox checked={true} />I fully understand and agree to the above
            terms.
          </div>

          <div
            className="text-block"
            style={{ fontSize: "14px", paddingLeft: "15px" }}
          >
            {text4}
          </div>

          {/* <div
            className="checkbox-container-margin"
            style={{ fontSize: "14px", paddingRight: "10px" }}
          >
            <Checkbox checked={true} />I fully understand and agree to the above
            terms.
          </div> */}

          <div className="signature-date-container">
            <div
              className="text-block-2"
              style={{ paddingLeft: "10px", fontSize: "14px" }}
            >
              Timestamp signature :{" "}
              {formatDate(props.GeneralLiabilityDateSigned)}{" "}
            </div>
            <div
              className="signature-title"
              style={{ paddingLeft: "5px", fontSize: "14px" }}
            >
              Client signature (
              <span style={{ fontWeight: "bold" }}>
                {props.firstName} {props.lastName}
              </span>
              ):
            </div>
            <img
              alt="Signature"
              className="signature-pic-roi"
              src={signaturePic}
            />
          </div>
        </div>
        <div className="line4-modal-percent-bis">
          <>
            <Button
              variant="contained"
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "12px",
              }}
              onClick={props.closemodal}
            >
              {translate("Cancel")}
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button
                  variant="contained"
                  style={{ marginLeft: "20px", fontSize: "12px" }}
                >
                  {translate("Print")}
                </Button>
              )}
              content={() => printRef.current}
              onAfterPrint={props.closemodal}
            />
          </>
        </div>
      </div>
    </>
  );
}

export default ViewGeneralLiabilityMobileV2;
